import { STRING, OBJECT_START, ARRAY_START, OBJECT_ARRAY_END, NULL, TRUE, FALSE, COLON, COMMA, NUMBER } from './token.mjs';

const rules = {
    quote: () => (source, pos) => {
        if (!source.startsWith("'", pos))
            return null;
        let i = pos;
        while (true) {
            if (source.length <= ++i) {
                throw new SyntaxError(`Unexpected end of Rison input`);
            }
            switch (source[i]) {
                case '!':
                    i++;
                    continue;
                case "'":
                    return { kind: STRING, value: source.slice(pos, i + 1) };
            }
        }
    },
    string: (kind) => (source, pos) => source.startsWith(kind, pos) ? { kind, value: kind } : null,
    regexp: (kind, reg) => (source, pos) => {
        const match = reg.exec(source.slice(pos));
        return match ? { kind, value: match[0] } : null;
    },
};
const RULES = [
    rules.quote(),
    rules.string(OBJECT_START),
    rules.string(ARRAY_START),
    rules.string(OBJECT_ARRAY_END),
    rules.string(NULL),
    rules.string(TRUE),
    rules.string(FALSE),
    rules.string(COLON),
    rules.string(COMMA),
    rules.regexp(STRING, /^[^0-9- '!:(),*@$][^ '!:(),*@$]*/),
    rules.regexp(NUMBER, /^-?([1-9][0-9]*|[0-9])(\.[0-9]+)?(e-?[0-9]+)?/),
];
class Lexer {
    source;
    pos = 0;
    constructor(source) {
        this.source = source;
    }
    position() {
        return this.pos;
    }
    length() {
        return this.source.length;
    }
    nextToken() {
        if (this.pos >= this.source.length)
            return null;
        for (const rule of RULES) {
            const token = rule(this.source, this.pos);
            if (token !== null) {
                this.pos += token.value.length;
                return token;
            }
        }
        throw new SyntaxError(`Unexpected token ${this.source[this.pos]} in Rison at position ${this.pos}`);
    }
    syntaxError(token) {
        const pos = this.pos - token.value.length;
        return new SyntaxError(`Unexpected token ${this.source[pos]} in Rison at position ${pos}`);
    }
}

export { Lexer };
//# sourceMappingURL=lexer.mjs.map
